<template>
    <BaseButton
        :class="['text-theme-icon transition', { 'invisible opacity-0': !showBackButton }]"
        :tooltip="localizations[lang].tooltips.back"
        dusk="closeReader"
        icon="baseline-arrow_back-24px"
        width="24px"
        height="24px"
        :disabled="!showBackButton"
        @click="backAction"
    />
</template>

<script>
import BaseButton from './BaseButton.vue';
import { mapGetters, mapMutations, mapState } from 'vuex';
import { uiAPI } from '../../../../src/js/communication';

export default {
    components: {
        BaseButton,
    },
    computed: {
        ...mapState(['localizations', 'lang']),
        ...mapGetters(['isEmbeddedMode', 'isOpenSomeFeatureOrSettings']),
        showBackButton() {
            if (!this.isEmbeddedMode) {
                return true;
            }

            return this.isOpenSomeFeatureOrSettings;
        },
    },
    methods: {
        ...mapMutations(['closeAllSettingsOrFeatures']),
        backAction() {
            if (this.isOpenSomeFeatureOrSettings) {
                this.closeAllSettingsOrFeatures();
                return;
            }

            uiAPI.close();
        },
    },
};
</script>
